import { useLocation } from "react-router-dom";
import DrawerButton from "./DrawerButton";
import { Assessment } from "@mui/icons-material";
import useUIBp from "../../../../../../Hooks/useUIBoilerplate";
import useURLQuery from "../../../../../../Hooks/useURLQuery";

const UIText = {
  "es-CL": { label: "Reportes" },
  "en-US": { label: "Reports" },
};

const Reports = () => {
  const { auth } = useUIBp();
  const location = useLocation().pathname.split("/")[2];
  const { group } = useURLQuery();
  const selected = location === "reports";
  const navTo = `/dashboard/reports?group=${group ? group : auth.group}`;
  const accentColor = selected ? "select.accent" : "primary.light";
  const icon = <Assessment {...{ sx: { color: accentColor } }} />;

  return <DrawerButton {...{ UIText, selected, navTo, icon, accentColor }} />;
};

export default Reports;
